import React from 'react';
import PropTypes from 'prop-types';
import { useOption } from 'react-aria';
import s from './ListBoxOption.module.scss';
/**
 * A listbox option based on react-aria from Adobe
 * Taken from https://react-spectrum.adobe.com/react-aria/useComboBox.html
 * @param {object} props - component props
 * @returns {object} - component jsx
 */
function ListBoxOption({ item, state }) {
  const ref = React.useRef();
  const { optionProps, isSelected, isFocused } = useOption(
    { key: item.key },
    state,
    ref
  );

  let className = s.listBoxOption;

  if (isSelected) {
    className = `${className} ${s.isSelected}`;
  } else if (isFocused) {
    className = `${className} ${s.isFocused}`;
  }

  return (
    <li
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...optionProps}
      ref={ref}
      className={className}
    >
      <div>{item.rendered}</div>
    </li>
  );
}

/* For detailed prop types see react-aria */
ListBoxOption.propTypes = {
  item: PropTypes.shape({
    key: PropTypes.string.isRequired,
    rendered: PropTypes.node.isRequired,
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object.isRequired,
};

export default ListBoxOption;
